export enum FileType {
  ExcelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
  CsvFileType = 'data:text/csv;charset=utf-8',
}
